import Quill from 'quill';
import { BlockEmbed } from 'quill/blots/block';

class DividerBlot extends BlockEmbed {
  static blotName = 'divider';

  static tagName = 'HR';

  static className = 'ql-divider';

  static create() {
    return super.create();
  }

  static value() {
    return true;
  }
}

let isRegistered = false;

export const registerQuillDivider = () => {
  if (isRegistered) return;
  Quill.register(DividerBlot);
  isRegistered = true;
};
